import TopicIcon from '@mui/icons-material/Topic';
import { Box } from '@mui/material';
import { type SxProps, type Theme, useTheme } from '@mui/material/styles';

type HelpCategoryIconProps = {
    iconUrl: string | null | undefined;
    selected?: boolean;
};

const bubbleSx = {
    bgcolor: '#C2E0FF',
    borderRadius: '999px',
    p: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
} as const;

type InlineSvgIconProps = {
    iconUrl: string;
    size: number;
    color: string;
    sx?: SxProps<Theme>;
};

function InlineSvgIcon({ iconUrl, size, color, sx }: InlineSvgIconProps) {
    return (
        <Box
            sx={{
                width: size,
                height: size,
                flexShrink: 0,
                display: 'block',
                bgcolor: color,
                WebkitMaskImage: `url("${iconUrl}")`,
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskSize: 'contain',
                WebkitMaskPosition: 'center',
                maskImage: `url("${iconUrl}")`,
                maskRepeat: 'no-repeat',
                maskSize: 'contain',
                maskPosition: 'center',
                ...sx,
            }}
            aria-hidden
        />
    );
}

export function HelpCategoryIcon({ iconUrl }: HelpCategoryIconProps) {
    const theme = useTheme();
    const color = theme.palette.primary.main;

    return (
        <Box sx={bubbleSx}>
            {iconUrl ? (
                <InlineSvgIcon iconUrl={iconUrl} size={24} color={color} />
            ) : (
                <TopicIcon sx={{ fontSize: 24, color: 'primary.main' }} />
            )}
        </Box>
    );
}

export function ChipHelpCategoryIcon({ iconUrl, selected }: HelpCategoryIconProps) {
    const theme = useTheme();
    const color = selected ? theme.palette.secondary.main : theme.palette.primary.main;

    if (!iconUrl) {
        return (
            <TopicIcon sx={{ fontSize: 18, color: selected ? 'secondary.main' : 'primary.main', ml: 1, mr: -0.5 }} />
        );
    }

    return (
        <InlineSvgIcon
            iconUrl={iconUrl}
            size={18}
            color={color}
            sx={{
                ml: 1,
                mr: -0.5,
            }}
        />
    );
}
